const SelectionModalCustomStyle = {
  content: {
    maxWidth: "580px",
    minHeight: "260px"
  }
};
const ExtendedSelectionModalCustomStyle = {
  content: {
    maxWidth: "580px",
    minHeight: "378px"
  }
};

export { ExtendedSelectionModalCustomStyle, SelectionModalCustomStyle };
//# sourceMappingURL=selectionModalCustomStyles.js.map
